// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderRoutePoint":"RoutePoints_tableHeaderRoutePoint__31JR1","tableRowRoutePoint":"RoutePoints_tableRowRoutePoint__l-pLg"};